/* eslint-disable no-console */
import ErrorBoundary from "@app/components/ErrorBoundary/ErrorBoundary"
import MaintenacePage from "@app/pages/MaintenacePage/MaintenacePage"
import { appStore } from "@app/store/store"
import { KioskBridge } from "@tecreation/bird5-kiosk-bridge"
import { MediaMatchProvider, ModalHandler, applyTheme } from "@tecreation/funnel-components"
import "@tecreation/funnel-components/dist/index.css"
import { StoreProvider } from "@tecreation/js-state-react"
import ReactDOM from "react-dom/client"
import { SkeletonTheme } from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"
import * as PACKAGE from "../package.json"
// import App from "./App"
import App, { PowChallengeSolver } from "./App"
import "./assets/fonts/fonts.css"
import "./assets/index.css"
import "./assets/reset.css"
import { useLogout } from "./store/service/authService"
import { IframeMessages } from "./utils/constants"
var version = PACKAGE.version

applyTheme({
	fontFamily: '"Roboto", sans-serif',
	colors: {
		fontColor: "var(--color-primary-900)",
	},
	fontSizes: {
		"00": "34px",
		0: "32px",
		1: "30px",
		2: "26px",
		3: "22px",
		4: "16px",
		5: "14px",
		6: "12px",
	},
})

/**
 * We Override the Date Constructor handle Dates like 'yyyy-mm-dd' correctly otherwhise the computers timezone get applied
 */
// eslint-disable-next-line no-global-assign
Date = class extends Date {
	constructor(...options) {
		if (!Array.isArray(options) && options) {
			options = [options]
		}

		if (options && options.length === 1 && typeof options[0] === "string" && options[0].match(/^\d\d\d\d[-]\d\d[-]\d\d$/)) {
			let hour = new Date().getTimezoneOffset() / 60
			if (hour <= 1) {
				hour = Math.abs(hour)
				if (("" + hour).length === 1) {
					hour = "0" + hour
				}
			} else {
				hour = "00"
			}

			options[0] += "T" + hour + ":00:00"
		}

		if (options?.length) {
			super(...options)
		} else {
			super()
		}
	}
}

//TODO: Investigate Bundle Size caused by font-awesome => we should import icons always only as single icon and not all icons
window.onload = async () => {
	if (window.location.href.includes("testapi-website.wund.de") || window.location.href.includes("funnel.local.de")) {
		document.body.insertAdjacentHTML(
			"afterbegin",
			`
            <a href="CHANGELOG.md?v=${new Date().getTime()}" target="_blank" style="position: absolute; top: 0; left: 50%; transform: translateX(-50%); z-index: 99">CHANGELOG</a>
        `,
		)
	}

	const params = new URLSearchParams(window.location.search)
	const htgGuestData = params.get("guestData")
	const language = params.get("language") || "de"
	const locationId = params.get("locationId")
	const zoneId = params.get("zoneId") || undefined
	const kiosk = params.get("kiosk") ? (params.get("kiosk") == "true" ? true : false) : false
	const source = params.get("source")
	const employee = params.get("employee") ? (params.get("employee") == "true" ? true : false) : false
	const onSiteLounger = params.get("onSiteLounger") ? (params.get("onSiteLounger") == "true" ? true : false) : false
	const view = params.get("view")
	const pFunnelToken = params.get("internal__funnelToken")
	const command = params.get("command")

	if (command == "logout") {
		await useLogout.blank()
		window.parent.postMessage(IframeMessages.openUrl, "*")
		return
	}

	if (kiosk || employee || onSiteLounger) {
		const disableCashregister = /true/i.test(params.get("stage-no-cashregister"))
		if (disableCashregister == false && (kiosk || employee || onSiteLounger)) {
			//We need to forward keypress events from the iframe to the cash window to reconize scans
			//We could also implement that here but idk if the cash app does something with the scan
			document.addEventListener("keypress", keyPress => {
				window.parent.postMessage(
					{
						keypress: {
							keyCode: keyPress.keyCode,
							which: keyPress.which,
							key: keyPress.key,
						},
					},
					"*",
				)
			})

			let clickActions = {
				topLeft: false,
				topRight: false,
				bottomLeft: false,
				bottomRight: false,
			}
			document.onclick = function (ev) {
				var x = ev.clientX
				var y = ev.clientY
				let margin = 0.1
				var width = document.documentElement.clientWidth
				var height = document.documentElement.clientHeight
				var margeX = width * margin
				var margeY = height * margin

				if (x < margeX && y < margeY) {
					clickActions.topLeft = true
					clickActions.topRight = false
					clickActions.bottomRight = false
					clickActions.bottomLeft = false
				} else if (x > width - margeX && y < margeY) {
					clickActions.topRight = true
					clickActions.bottomRight = false
					clickActions.bottomLeft = false
				} else if (x > width - margeX && y > height - margeY) {
					clickActions.bottomRight = true
					clickActions.bottomLeft = false
				} else if (x < margeX && y > height - margeY) {
					clickActions.bottomLeft = true
					if (clickActions.topLeft == true && clickActions.topRight == true && clickActions.bottomRight == true && clickActions.bottomLeft == true) {
						clickActions = {
							topLeft: false,
							topRight: false,
							bottomLeft: false,
							bottomRight: false,
						}
						KioskBridge.execute("window.kiosk.method.login", {
							sendEvent: true,
						})
					} else {
						clickActions.topLeft = false
						clickActions.topRight = false
						clickActions.bottomRight = false
						clickActions.bottomLeft = false
					}
				} else {
					clickActions.topLeft = false
					clickActions.topRight = false
					clickActions.bottomRight = false
					clickActions.bottomLeft = false
				}
			}

			KioskBridge.execute("cashregister.shift.kiosk.checkBatch")
			KioskBridge.execute("cashregister.kiosk.getCashregister").then(cash => {
				appStore.set("core.cashregister", cash)
			})
			try {
				await KioskBridge.execute("receipt.kiosk.stop")
			} catch (e) {
				console.error(e)
			}
		}
	}

	if (employee && window.top === window.self && process.env.NODE_ENV !== "development") {
		return
	}

	const render = settings => {
		let locationSettings = settings.locations[locationId]

		if (!locationSettings) {
			console.error("can't find settings for locationid: " + locationId)
		}

		let funnelToken = locationSettings.funnelTokens[htgGuestData ? "htg" : kiosk ? "kiosk" : employee || onSiteLounger ? "employee" : "website"]

		if (view && view.startsWith("tablet-immersive-room")) {
			funnelToken = locationSettings.funnelTokens["immersiveSky"]
		} else if (view && view.startsWith("tablet-sauna-boat")) {
			funnelToken = locationSettings.funnelTokens["saunaBoat"]
		} else if (view && view.startsWith("tablet-surf-wave")) {
			funnelToken = locationSettings.funnelTokens["surfWave"]
		}

		if (pFunnelToken) {
			funnelToken = pFunnelToken
		}

		//init appStore
		appStore.set(state => ({
			core: {
				...state.core,
			},
			settings: {
				...locationSettings,
				connectorKey: source === "7d" ? locationSettings.connector7DKey : locationSettings.connectorKey,
				funnelToken: funnelToken,
				cmsUrl: locationSettings.cmsUrl + "items",
				cmsAssetsUrl: locationSettings.cmsUrl + "assets",
				locationCmsUrl: locationSettings.locationCmsUrl + "items",
				locationCmsAssetsUrl: locationSettings.locationCmsUrl + "assets",
				employeeNewsUrl: settings.employeeNewsUrl + locationSettings.employeeNewsCategories,
				blockedVoucherDetailIds: settings.blockedVoucherDetailIds,
			},
		}))

		appStore.set("core.zoneId", zoneId)
		const root = ReactDOM.createRoot(document.getElementById("root"))
		root.render(
			<ErrorBoundary>
				<StoreProvider store={appStore}>
					{settings.maintenance ? (
						<MaintenacePage />
					) : (
						<MediaMatchProvider>
							<SkeletonTheme baseColor="#dddddd" highlightColor="#efefef">
								<ModalHandler>
									<PowChallengeSolver>
										<App locationId={locationId} language={language} kiosk={kiosk} source={source} onSiteLounger={onSiteLounger} />
									</PowChallengeSolver>
								</ModalHandler>
							</SkeletonTheme>
						</MediaMatchProvider>
					)}
				</StoreProvider>
			</ErrorBoundary>,
		)
	}

	fetch("settings.json?v=" + new Date().getTime())
		.then(async rsp => {
			const settings = await rsp.json()
			render(settings)
		})
		.catch(() => {
			console.warn("didn't could find settings file search for default settings..")
			fetch("defaultSettings.json?v=" + version).then(async rsp => {
				console.log("defaultSettings found..")
				const settings = await rsp.json()
				render(settings)
			})
		})
}
